import { useCallback } from "react";
import type { MatomoWindow } from "./useMatomoTagManager";
/**
 * trackEvent is a function that tracks events with Matomo.
 * It takes a category, action, name and value as parameters.
 * Ex: trackEvent("Project", "Click", "Open Fault Events", 1);
 */
type TrackEventParams = {
  category: string; // ex: "Project"
  action: string; // ex: "Click"
  name?: string; // ex: "Open Fault Events"
  value?: number; // ex: 1
};

export const useMatomoTrackEvent = () => {
  const trackEvent = useCallback((params: TrackEventParams) => {
    if (typeof window === "undefined") return;
    const matomoWindow = window as MatomoWindow;
    if (!matomoWindow._paq) return;

    const { category, action, name, value } = params;

    const eventPayload: (string | number)[] = ["trackEvent", category, action];
    if (name) eventPayload.push(name);
    if (typeof value === "number") eventPayload.push(value);

    matomoWindow._paq.push(eventPayload);
  }, []);

  return trackEvent;
};
